import { Bookmark } from '../components/Bookmark';
import { useBookmarkService } from '../services/useBookmarkService';

export const BookmarkContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { is_preview, is_visible_bookmark_count, bookmark_status, setBookmark } = useBookmarkService();

  return (
    <Bookmark
      bookmark_status={bookmark_status}
      setBookmark={setBookmark}
      is_preview={is_preview}
      is_visible_bookmark_count={is_visible_bookmark_count}
    />
  );
};
